/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ArchiveEntityTypeEnum = "containers" | "shipments" | "%future added value";
export type infoUnarchiveItemInput = {
    clientMutationId?: string | null;
    entitySlug: string;
    entityType: ArchiveEntityTypeEnum;
};
export type ArchiveActionsUnarchiveMutationVariables = {
    input: infoUnarchiveItemInput;
};
export type ArchiveActionsUnarchiveMutationResponse = {
    readonly infoUnarchiveItem: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ArchiveActionsUnarchiveMutation = {
    readonly response: ArchiveActionsUnarchiveMutationResponse;
    readonly variables: ArchiveActionsUnarchiveMutationVariables;
};



/*
mutation ArchiveActionsUnarchiveMutation(
  $input: infoUnarchiveItemInput!
) {
  infoUnarchiveItem(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUnarchiveItemPayload",
    "kind": "LinkedField",
    "name": "infoUnarchiveItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArchiveActionsUnarchiveMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArchiveActionsUnarchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f22e146bc961410be99a409d60cab29",
    "id": null,
    "metadata": {},
    "name": "ArchiveActionsUnarchiveMutation",
    "operationKind": "mutation",
    "text": "mutation ArchiveActionsUnarchiveMutation(\n  $input: infoUnarchiveItemInput!\n) {\n  infoUnarchiveItem(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd856f455306287c0d9e38a82b4960899';
export default node;
